import { Component } from '@angular/core';
import { BaseFormTableComponent } from '../base/base-form-table.component';

/**
 * 雙檔表單頁面的抽象類別，繼承 BaseFormTableComponent。
 *
 * @export
 * @abstract
 * @class SimpleDoubleComponent
 * @extends {BaseFormTableComponent}
 */
@Component({
  template: ''
})
export abstract class SimpleDoubleComponent extends BaseFormTableComponent {

  /**
   * 雙檔的刪除都變成清除，因為只是從畫面移除
   */
  // override rowDeleteChangeToClear: boolean = true;

  /**
   * 一般狀況下雙檔單頭取消之前應該不會需要做什麼額外的事情。
   * 所以什麼都不處理就 return，有需要的再自己 override。
   */
  override async beforeMasterMenuDiscard(): Promise<boolean> {
    return true;
  }

  /**
   * 一般狀況下雙檔單頭取消之前應該不會需要做什麼額外的事情。
   * 所以什麼都不處理就 return，有需要的再自己 override。
   */
  override async beforeMasterMenuSubmit(): Promise<boolean> {
    return true;
  }

  /**
   * 雙檔 Detail 刪除就直接從資料移除就好，最後才一起送到後端異動。
   */
  override async doRowActionDelete(): Promise<boolean> {
    return true;
  }

  /**
   * 基本雙檔畫面不會改變 Detail 狀態。
   * 所以實作 return。
   */
  override afterDetailMenuStatusChange(): void {
    return;
  }

  /**
   * Table 上方的功能選單 - Add 按下去後預設要做的事情。
   * (1) 先驗證單頭檢核通過
   * (2) 呼叫父類別的 detailMenuAddCommand()
   */
  override detailMenuAddCommand(): void {
    console.log('SimpleDoubleComponent detailMenuAddCommand');

    // 雙檔的新增要確定單頭都沒有錯誤後才能新增
    this.submitted = true;
    if (!this.formGroup.valid) {
      return;
    }

    super.detailMenuAddCommand();
  }

  /**
   * 為了避免影響既有程式，預設不提供批次刪除
   * 有需要的再自己 override
   */
  override async doDetailMenuBatchDelete(): Promise<boolean> {
    return true;
  }
}
